import React from 'react'

import { withTranslation } from 'react-i18next'

import { Page } from '../../components/Page/Page'
import { PageInfo } from '../../components/PageInfo/PageInfo'
import { PKS_NEWS_CATEGORY } from '../../../config/pks-constants'
import { TopNews } from '../../components/TopNews/TopNews'
import { AllNews } from '../../components/AllNews/AllNews'

const News = ({ t }) => (
    <Page>
        <PageInfo
            breadcrumbs={t('generalNews.breadcrumbs')}
            title={t('generalNews.title.default')}
            bgImage="/images/vest.jpg"
            overlay
        />
        <TopNews
            id={PKS_NEWS_CATEGORY.NEWS_HOME_CATEGORY}
            queryParam={'news_category_id'}
            title={t('generalNews.topNews.title')}
            withApproval
        />
        <AllNews
            id={PKS_NEWS_CATEGORY.NEWS_HOME_CATEGORY}
            queryParam={'news_category_id'}
            title={t('generalNews.allNews.title')}
            excludeMarkedNews
            withApproval
        />
        <AllNews
            id={PKS_NEWS_CATEGORY.REGIONAL_CHAMBERS}
            queryParam={'news_category_id'}
            title={t('regionalNews.title')}
            withApproval
        />
        <AllNews
            id={PKS_NEWS_CATEGORY.SUCCESSFUL_STORIES}
            queryParam={'news_category_id'}
            title={t('successfulStories.title')}
            withApproval
        />
    </Page>
)

export default withTranslation()(News)
